import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { getUserData } from "../../utils/utils";
interface RouteGuardType {
  children: React.JSX.Element;
  permissionName?: string;
}

function RouteGuard({ children, permissionName = "" }: RouteGuardType) {
  const userData = useSelector((state: any) => state.auth.userData);
  const data = getUserData();
  return !!userData?.access_token || !!data?.access_token ? children : <Navigate to={"/"} />;
}

export default RouteGuard;
